const CustomerImport = () => import('@/components/SuperAdmin/Import/CustomerImport')

export default [
	{
		component: CustomerImport,
		name: 'sa-customer-import',
		path: 'customer-import'
	}
]
